import { deliveryMethods, freeShippingRules } from "@/config/storeConfig";
import { panelModes } from "@/mocks/panelContent";
import { formatBRL } from "@/lib/format";
import { FieldRow, LockedButton, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function DeliverySection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="Formas de recebimento"
        description="Cada modalidade pode ser ativada, ajustada e ter regras próprias. Os valores são demonstrativos e ficam centralizados em uma configuração própria."
        action={<PanelBadge tone="primary">{deliveryMethods.length} modalidades</PanelBadge>}
      >
        <div className="flex flex-col gap-4">
          {deliveryMethods.map((method) => (
            <article key={method.id} className="rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-lg text-foreground-900">{method.name}</h3>
                  <PanelBadge tone={method.available ? "primary" : "neutral"}>
                    {method.available ? "Disponível" : "Indisponível"}
                  </PanelBadge>
                  {method.requiresCep ? <PanelBadge tone="secondary">Exige CEP</PanelBadge> : null}
                  {method.requiresAddress ? <PanelBadge tone="secondary">Exige endereço</PanelBadge> : null}
                  {method.requiresBus ? <PanelBadge tone="secondary">Exige dados de ônibus</PanelBadge> : null}
                </div>
                <LockedButton icon="ri-edit-2-line">Editar modalidade</LockedButton>
              </div>

              <div className="mt-3 rounded-md border border-background-200 bg-background-100 px-3 py-1">
                <FieldRow label="Descrição" value={method.description} />
                <FieldRow label="Prazo" value={method.deadline} />
                <FieldRow
                  label="Taxa fixa"
                  value={method.fee === null ? "Taxa a confirmar" : formatBRL(method.fee)}
                />
                <FieldRow label="Regiões atendidas" value={method.regions} />
                <FieldRow label="Pedido mínimo" value={method.minOrder ? formatBRL(method.minOrder) : "Sem mínimo"} />
                <FieldRow label="Aviso" value={method.notice ?? "—"} />
              </div>
            </article>
          ))}
        </div>
      </PanelCard>

      <PanelCard
        title="Regras de frete grátis"
        description="Estrutura configurável por valor, cidade, bairro, faixa de CEP, modalidade e período de campanha."
      >
        <div className="flex flex-col gap-3">
          {freeShippingRules.map((rule) => (
            <div key={rule.id} className="rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base text-foreground-900">{rule.label}</h3>
                  <PanelBadge tone={rule.enabled ? "primary" : "neutral"}>
                    {rule.enabled ? "Ativa" : "Desativada"}
                  </PanelBadge>
                </div>
                <LockedButton icon="ri-toggle-line" hint="Ativar ou desativar regra">
                  Ativar / desativar
                </LockedButton>
              </div>
              <div className="mt-3 rounded-md border border-background-200 bg-background-100 px-3 py-1">
                <FieldRow label="Modalidades" value={rule.methodIds.join(", ")} />
                <FieldRow label="Valor mínimo" value={rule.minValue ? formatBRL(rule.minValue) : "—"} />
                <FieldRow label="Cidades" value={rule.cities?.join(", ") ?? "—"} />
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-xs leading-relaxed text-foreground-600">
          Regra demonstrativa atual: entrega local gratuita em Goiânia para pedidos a partir de
          R$ 500,00. A regra não se aplica aos Correios, transportadora ou envio por ônibus, e é
          editável pela Vellora. O valor da entrega entra no resumo e na mensagem final do pedido.
        </p>
      </PanelCard>
    </div>
  );
}